export default "__VITE_ASSET__b7e412f1__"